import { TaskType } from "@common/types/task";
import { getTaskPreviewDefinition } from "@components/drawers/taskCreationPreviewRegistry";

export const hasFullscreenPreview = (taskType: TaskType | null): boolean =>
    getTaskPreviewDefinition(taskType)?.hasTemplatePreview ?? false;
